// composables/useIntranetAuth.js
export const useIntranetAuth = () => {
  const auth = useAuthIntranetStore();
  const { $apiMethods } = useNuxtApp();
  const config = useRuntimeConfig();

  /**
   * Fetches the current user from the intranet API.
   * @returns {Promise<Object|null>} The user object or null if failed.
   */
  const fetchUser = async () => {
    try {
      const res = await $apiMethods.loadJSONApi($apiMethods.getApiHostUrl()+'/api/login/intranet/user');
      return res.user;
    } catch (err) {
      console.error('Failed to fetch user:', err);
      auth.clearLoginData(); // Clear user data on error
      return null;
    }
  };
  const exchangeCode = async (code) => {
    try {
      const res = await $apiMethods.postApiCall($apiMethods.getApiHostUrl() +'/api/login/intranet/exchangeCode',{code:code}); 
      // Validate response
      if (!res.user || !res.token) {
        throw new Error('Ongeldige response van de server: ontbrekende user of token');
      }
      auth.handleDoLogin(res.user);
      auth.setToken(res.token);

      return res.user;
    } catch (err) {
      console.error('Failed to fetch user:', err);
      auth.clearLoginData(); // Clear user data on error
      return null;
    }
  };
  /**
   * Returns the frontend intranet login page path.
   * @returns {string}
   */
  const goToLoginPageFrontendIntranet = () => {
    return '/auth/intranet/intranetLogin';
  };

  /**
   * Checks if the current environment is intranet.
   * @returns {boolean}
   */
  const isIntranet = () => {
    return config.public.IS_INTRANET === 1;
  };

  /**
   * Redirects to the backend intranet login.
   */
  const loginIntranetBackend = () => {
    
    window.location.href = $apiMethods.getApiHostUrl()+'/api/login/intranet';
  };
  const useIntranetLogin = () =>{
    return true;
  }
  /**
   * Logs the user out and redirects to the login page. this should not happen 
   */
  const logout = async () => {
    
    try {
        await $apiMethods.postApiCall($apiMethods.getApiHostUrl()+'/api/login/intranet/logout',[]); 
    } catch (error) {
      console.error('Failed to logout:', error);

    } finally {
      auth.clearLoginData();
      await navigateTo({
        path: goToLoginPageFrontendIntranet(),
        replace: true, // Replace historie-entry
      });
    }
  };

  const setReturnUrl = (url) => {
    if (typeof url !== 'string' || !url.trim()) {
      return;
    }
    const returnUrlCookie = useCookie('returnUrl',{
      maxAge: 120
    }) // 2 min
    returnUrlCookie.value = url
  }
  const getReturnUrl = (deleteCookie) =>{
    const returnUrlCookie = useCookie('returnUrl', { default: () => '/' })
    const returnUrl = returnUrlCookie.value?returnUrlCookie.value:"/"
    if (deleteCookie){
      returnUrlCookie.value = null
    }
    return returnUrl
  }

  return {
    exchangeCode,
    fetchUser,
    loginIntranetBackend,
    logout,
    goToLoginPageFrontendIntranet,
    useIntranetLogin,
    isIntranet,
    setReturnUrl,
    getReturnUrl
  };
};
